import { render, staticRenderFns } from "./messageList copy.vue?vue&type=template&id=34c0530e"
import script from "./messageList copy.vue?vue&type=script&lang=js"
export * from "./messageList copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c0530e')) {
      api.createRecord('34c0530e', component.options)
    } else {
      api.reload('34c0530e', component.options)
    }
    module.hot.accept("./messageList copy.vue?vue&type=template&id=34c0530e", function () {
      api.rerender('34c0530e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/systemManage/messageList copy.vue"
export default component.exports